module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/cliente-pyme/cliente-pyme.component.css
// module id = ./src/app/components/cliente-pyme/cliente-pyme.component.css
// module chunks = main